export const ACQ_TIME_CHANNEL = 'AcqTime';
